import { render, staticRenderFns } from "./EditConclusion.vue?vue&type=template&id=6b8c63d1&scoped=true"
import script from "./EditConclusion.vue?vue&type=script&lang=js"
export * from "./EditConclusion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c63d1",
  null
  
)

export default component.exports